import { UNIT, mainColor } from '../../constants/theme';

export const styles = () => ({
  progress: {
    margin: UNIT * 2,
    textAlign: 'center',
    color: mainColor.secondaryColor,
    marginTop: UNIT * 1.25,
    marginBottom: UNIT * 1.25
  },
  body: {
    width: '100%',
    display: 'flex',
    padding: UNIT * 0.625
  },

  subtitle: { fontWeight: 'bold' },
  designText: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bold',
    alignSelf: 'center',
    paddingBottom: UNIT * 0.3125,
    paddingTop: UNIT * 1.125
  },
  paper: { marginTop: UNIT * 0.625, padding: '0px 0px 10px 5px', width: '100%' },
  bottomNavigProduct: {
    border: '1px solid #f2efef',
    height: `${UNIT * 17.3125}%`,
    borderRadius: UNIT * 0.375,
    marginTop: UNIT * 0.75,
    maxWidth: '100%',
  },

  verticalStyle: {
    marginTop: UNIT * 8,
    marginLeft: `${UNIT * 1.3125}%`
  },
  horizontalStyle: {
    marginTop: UNIT * 8,
    float: 'right',
    marginRight: `${UNIT * 1.3125}%`
  },
  horizontalProductIcon: {
    width: UNIT * 6.5625,
    marginBottom: UNIT * 2.1875,
    marginTop: UNIT * 1.375
  },
  verticalProductIcon: {
    width: UNIT * 3.25,
    marginBottom: UNIT * 1.375
  },
  paperStyle: {
    paddingTop: UNIT * 0.625,
    borderRadius: '0px 16px 16px 0px!important',
    margin: -UNIT * 0.625,
    paddingBottom: UNIT * 0.625,
    height: UNIT * 37.5
  },
  gutters: {
    paddingLeft: 30,
    paddingRight: 30
  },
  listStyle: {
    marginTop: -UNIT * 1.125,
    marginBottom: -UNIT * 0.5,
    borderTopRightRadius: UNIT
  },
  textStyle: {
    fontSize: UNIT * 0.75
  },
  configStyle: {
    fontSize: UNIT * 0.875,
    fontWeight: 'bold',
    color: 'black!important'
  },
  darkColor: {
    color: '#646777'
  },
  configText: {
    color: mainColor.colorBlack,
    marginLeft: -UNIT * 1.5
  },
  checkOutStyle: {
    color: '#f2efef',
    fontSize: UNIT * 1.8125,
    marginTop: -UNIT * 0.1875
  },
  heightImage: {
    height: UNIT * 36
  },
  row: {
    display: 'flex',
    margin: 'auto'
  },
  designStyle: {
    width: 'fit-content',
    margin: 'auto'
  },
  coverImage: {
    objectFit: 'cover'
  }
});
